import React from 'react'
import { createRoot } from 'react-dom/client'

import { changeLanguage } from 'shared-components'

import App from './components/App'

import { APP_VERSION } from './constants'
import './datadog.js'
import i18n from './i18n'

console.debug('finderCONNECT version:', APP_VERSION)
changeLanguage(i18n, new URLSearchParams(window.location.search).get('lng'))
const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(<App />)
